// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"c992c1c1","667":"d41ee6b3","735":"68f458a8","787":"06a16d87"}[chunkId] + ".chunk.js";
};